import { render } from "./LoadingModal.vue?vue&type=template&id=74fecd81&scoped=true"
import script from "./LoadingModal.vue?vue&type=script&lang=js"
export * from "./LoadingModal.vue?vue&type=script&lang=js"

import "./LoadingModal.vue?vue&type=style&index=0&id=74fecd81&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fecd81"]])

export default __exports__